import MarketerProfilePictureForm from './MarketerProfilePictureForm';

export default MarketerProfilePictureForm;
